import { useContext, useEffect } from "react";
import { titleFromParams } from "../../Utilities/helperFunction";
import appContext from "../../appContext";
import "./style.scss";

const Linkedin = ({
  mock,
  index,
  setMaintainValues,
  maintainValues,
  setValue,
}) => {
  const { setCustomStyles, linkedInDetails } = useContext(appContext);
  const id = sessionStorage.getItem("id") || "";

  useEffect(() => {
    setCustomStyles(mock?.styles || {});
  }, []);

  useEffect(() => {
    if (Object.keys(linkedInDetails || {}).length) {
      setValue(mock?.name, linkedInDetails);
      setMaintainValues({
        ...maintainValues,
        [`${mock?.name}`]: linkedInDetails,
      });
    }
  }, [linkedInDetails]);

  return (
    <div className="linkedin-container">
      <div className="linkedin-title">
        <h1 className="title">
          <span>
            {index}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="10"
              viewBox="0 0 24 24"
            >
              <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z" />
            </svg>
          </span>
          <div
            dangerouslySetInnerHTML={{ __html: titleFromParams(mock?.title) }}
          />
        </h1>
        <div
          className="description-container"
          dangerouslySetInnerHTML={{ __html: mock?.description }}
        />
      </div>
      <iframe
        title="Executive summary Linkedin Login"
        frameborder="0"
        height="50px"
        src={`${process.env.REACT_APP_LINKEDIN_LOGIN_URL}/login?id=${id}&status=update&isBackground=false`}
      ></iframe>
    </div>
  );
};

export default Linkedin;
